routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.eventDetail', {
       url: __env.routes.eventDetail,
       template: `<event-detail   sh-ctrl="shCtrl"></event-detail>`
    })

}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/events/event-detail/event-detail.config.js